import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { useOnboardingCallActionShallowStore } from '../hooks/use-onboarding-call-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useReviewConversationAnalysisAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();
  const { eligibility, isEligibilityResolved, setPendingTask } = useOnboardingCallActionShallowStore(
    'eligibility',
    'isEligibilityResolved',
    'setPendingTask'
  );

  return {
    isEnabled: eligibility.hasEligibleCall,
    isLoading: !isEligibilityResolved,
    onSelect: () => {
      setPendingTask(OnboardingBaseTask.BASE_TASK_REVIEW_CONVERSATION_ANALYSIS);
      navigate({ to: '/calls/call-history' });
      onClose();
    },
  };
}
